export default "__VITE_ASSET__rgsrOx8Z__"